export default "__VITE_ASSET__Cpxte80p__"